export function PageLoader() {
  return (
    <div className="app-page-loader" role="status" aria-live="polite" aria-busy="true">
      Loading…
    </div>
  )
}
